export enum LoanAppStatus {
    Pending = "Pending",
    Hold = "Hold",
    Approved = "Approved",
    Rejected = "Rejected"
  }

export enum LoanStatus
{
     New = "New",
     InFunding = "InFunding",
     Disbursed = "Disbursed",
     BadStanding = "BadStanding",
     OverDue = "OverDue",
     Closed = "Closed",
     Due = "Due",
     Pending = "Pending",
     Rejected = "Rejected",
     OverPaid = "OverPaid",
     WrittenOff = "WrittenOff",
}

export enum PaymentTransactionMode
{
  Online = "Online",
  Cash = "Cash"
}

export enum AppModuleType
{
  Saccos = "1",
  Merrygoround = "2",
  Microfinance = "3",
}

export enum PolicyStatus
{
  Accepted = "Accepted",
  Rejected = "Rejected"
}

export enum CUModes {
  STARTER = "STARTER",
  STANDARD = "STANDARD",
}

export enum CreditUnionStatus{
  Requested = 'Requested',
  Active = 'Active',
  Blocked = 'Blocked',
  Rejected = 'Rejected'
}
export enum CreditUnionFeatures{
Loan = 'Loan',
Shares = 'Shares',
Saving = 'Saving'
}

export enum SavingProductType {
  Saving = "Saving",
  Current = "Current",
  Deposits = "Deposits",
  FixedDeposits = "FixedDeposits",
  RecurringDeposits = "RecurringDeposits"
}

export enum TransactionStatus{
  Pending = "PENDING",
  Failed = "FAILED",
  Success = "SUCCESS",
  Initiated = "INITIATED"
}
export enum RepaymentType{
  PayCurrentOutstanding = "PayCurrentOutstanding",
  PastDue = "PastDue",
  CurrentDue = "CurrentDue",
}

export enum FeePaymentType{
  Outstanding = "Outstanding",
  Partialpayment = "Partialpayment"
}
export enum QuickLoan{
  QuickLoan = "QuickLoan"
}
export enum ErrorCorrectionEnum {
  Journal = "Journal",
  Contra = "Contra",
  Repayment = "Repayment",
  Disburse = "Disburse",
  Deposit = "Deposit",
  Withdraw = "Withdraw",
  FeeAndPenalties = "FeeAndPenalties",
  OtherIncome = "OtherIncome",
  ApplicationCharge = "ApplicationCharge",
  ReverseRepayment = "ReverseRepayment",
}